import { withAsyncEnterLoader, withLoader } from 'util/routeHelper';
import { getCommunity, getCommunityCity } from 'actions/community';

export default store => ({
	path: 'community',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'Community',
				),
			store,
			'COMMUNITY',
		),
		onEnter: withAsyncEnterLoader(
			async (_, __, updateRatio) => {
				updateRatio(0.3);

				await store.dispatch(getCommunityCity());
				await store.dispatch(getCommunity());

				updateRatio(0.8);
			},
			store,
			'ENTER_COMMUNITY',
		),
	},
});



// WEBPACK FOOTER //
// ./src/routes/User/Community/index.js